module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"title":"Saulės moduliai","guarantee":"Produkto garantija:","power":"Modulio galia:","size":"Modulio matmenys:"}}')
  delete Component.options._Ctor
}
